module.exports = __webpack_public_path__ + "img/analysis.f788d5d6.svg";